<template>
  <question-item
    :question="question"
    :operates="['remove', 'move']"
    :more-operates="['remove', 'move']"
    :seniors="['editor', 'image']"
    v-bind="$attrs"
    v-on="$listeners"
    @batch-delete="batchDelete"
    @batch-move="batchMove"
  />
</template>

<script>
import QuestionItem from '@/question/components/QuestionItem'
import { REMOVE_QUESTION_LIST, MOVE_QUESTION_LIST } from '@/assets/js/config/bus'
import { clearPopup, createPopup } from '@/assets/js/factory'
import BatchDelete from '@/question/components/popup/BatchDelete'
import BatchMove from '@/question/components/popup/BatchMove'

export default {
  name: 'SectionQuestion',
  props: {
    question: {
      type: Object,
      default: () => ({})
    }
  },
  components: { QuestionItem },
  created() {},
  methods: {
    batchDelete() {
      const vm = createPopup(
        BatchDelete,
        {},
        {
          store: this.$store
        }
      )
      vm.$on('confirm', removeList => {
        this.$surveyBus.$emit(REMOVE_QUESTION_LIST, removeList, flag => {
          vm.loading = false
          if (flag) {
            vm.$emit('close')
          }
        })
      })
    },
    batchMove() {
      const vm = createPopup(
        BatchMove,
        {},
        {
          store: this.$store
        }
      )
      vm.$on('confirm', data => {
        this.$surveyBus.$emit(MOVE_QUESTION_LIST, data, flag => {
          vm.loading = false
          if (flag) {
            vm.$emit('close')
          }
        })
      })
    },
  },
  beforeDestroy() {
    clearPopup()
  }
}
</script>
